"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const navigationHelpers_1 = require("evolution-common/lib/services/questionnaire/sections/navigationHelpers");
const widgetsNames_1 = require("./widgetsNames");
const customPreload_1 = require("./customPreload");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const moment_1 = __importDefault(require("moment"));
exports.currentSectionName = 'home';
const previousSectionName = null;
const nextSectionName = 'household';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Domicile',
        en: 'Home'
    },
    navMenu: {
        type: 'inNav',
        menuName: {
            fr: 'Domicile',
            en: 'Home'
        }
    },
    widgets: widgetsNames_1.widgetsNames,
    // Do some actions before the section is loaded
    preload: customPreload_1.customPreload,
    // Allow to click on the section menu
    enableConditional: true,
    // Allow to click on the section menu
    completionConditional: function (interview) {
        return (0, navigationHelpers_1.isSectionCompleted)({ interview, sectionName: exports.currentSectionName });
    },
    onSectionEntry: function (interview, _iterationContext) {
        const previousDay = (0, helpers_1.getResponse)(interview, '_previousDay');
        if (!previousDay) {
            return { 'response._previousDay': (0, moment_1.default)().subtract(1, 'days').format('YYYY-MM-DD') };
        }
        return undefined;
    }
};
exports.default = exports.sectionConfig;
